import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedAdmin({ children }) {
  const [ok, setOk] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem("clae_token")) { setOk(false); return; }
    api.get("/auth/me").then(() => setOk(true)).catch(() => setOk(false));
  }, []);
  if (ok === null) return <div className="p-10 mono-label">Loading…</div>;
  if (!ok) return <Navigate to="/admin/login" replace />;
  return children;
}
